export const DISTRICTS = [
  {
    slug: "mitte",
    name: "Mitte",
    tagline: "Gastronomie, Hotels, Altbau & Regierungsviertel",
    ortsteile: ["Mitte", "Moabit", "Hansaviertel", "Tiergarten", "Wedding", "Gesundbrunnen"],
    intro: [
      "Berlin-Mitte ist der dichteste Bezirk der Stadt: Restaurants, Hotels, Büros und Wohnhäuser liegen hier Wand an Wand. Wo viele Lebensmittel umgeschlagen werden und Müllbehälter rund um die Uhr gefüllt sind, finden Ratten ideale Bedingungen — besonders in den Hinterhöfen rund um Hackescher Markt, Rosenthaler Platz und in den Wohnblöcken von Wedding und Moabit.",
      "Rodex Berlin bekämpft Ratten und Mäuse in Mitte diskret und nach BfR-Leitlinien — mit neutralen Fahrzeugen, damit Gäste, Mieter und Kunden nichts davon mitbekommen. Für Gastronomie und Hotellerie dokumentieren wir jeden Einsatz HACCP-konform.",
    ],
    hotspots: [
      "Müllstandplätze in Hinterhöfen von Gastronomie und Hotels",
      "Altbaukeller mit offenen Rohrdurchführungen in Wedding und Moabit",
      "Grünanlagen und Uferbereiche an Spree und Spandauer Schifffahrtskanal",
      "Lager- und Anlieferzonen von Geschäften und Supermärkten",
    ],
    faqs: [
      {
        q: "Kommen Sie auch diskret zu einem Restaurant in Mitte?",
        a: "Ja. Wir arbeiten mit neutralen Fahrzeugen und ohne auffällige Beschriftung, auf Wunsch außerhalb der Öffnungszeiten. Die Dokumentation erhalten Sie HACCP-konform für Ihre Unterlagen.",
      },
      {
        q: "Wer ist bei Ratten im Hinterhof in Mitte zuständig — Mieter oder Vermieter?",
        a: "In der Regel ist der Eigentümer bzw. die Hausverwaltung für die Bekämpfung auf dem Grundstück verantwortlich. Melden Sie den Befall daher zuerst Ihrer Verwaltung — wir arbeiten direkt mit Hausverwaltungen zusammen.",
      },
    ],
  },
  {
    slug: "friedrichshain-kreuzberg",
    name: "Friedrichshain-Kreuzberg",
    tagline: "Altbau, Spätis, Bars & Uferlagen",
    ortsteile: ["Friedrichshain", "Kreuzberg"],
    intro: [
      "Friedrichshain-Kreuzberg ist geprägt von Gründerzeit-Altbauten, belebten Kiezen und einer der höchsten Gastronomie-Dichten Berlins. Rund um Landwehrkanal, Spree, Görlitzer Park und die Märkte am Maybachufer finden Ratten Nahrung und Unterschlupf — von dort ziehen sie in Keller, Hinterhöfe und Erdgeschoss-Gewerbe.",
      "Wir bekämpfen Ratten und Mäuse in Friedrichshain und Kreuzberg gezielt mit verschlossenen Köderboxen — sicher für Kinder, Hunde und Hofkatzen. Nach der Bekämpfung analysieren wir, wo die Tiere ins Gebäude gelangen, und geben Ihnen schriftliche Empfehlungen.",
    ],
    hotspots: [
      "Hinterhöfe mit Gewerbe- und Gastronomiemüll",
      "Altbaukeller mit maroden Kellerfenstern und Lichtschächten",
      "Uferbereiche an Landwehrkanal und Spree",
      "Parks und Grünflächen wie Görlitzer Park oder Volkspark Friedrichshain",
    ],
    faqs: [
      {
        q: "Ich habe eine Maus in meiner Altbauwohnung in Kreuzberg gesehen — was tun?",
        a: "Mäuse kommen selten allein. Achten Sie auf Kot, Nagespuren an Lebensmitteln und Geräusche in Wänden. Rufen Sie uns an — wir finden heraus, wo die Tiere herkommen, und bekämpfen den Befall gezielt.",
      },
      {
        q: "Sind die Köder für Hunde im Hof gefährlich?",
        a: "Wir setzen ausschließlich verschlossene, sabotagesichere Köderboxen ein. Hunde, Katzen und Kinder kommen an den Köder nicht heran.",
      },
    ],
  },
  {
    slug: "pankow",
    name: "Pankow",
    tagline: "Prenzlauer Berg, Weißensee & grüne Randlagen",
    ortsteile: ["Prenzlauer Berg", "Weißensee", "Pankow", "Niederschönhausen", "Heinersdorf", "Französisch Buchholz", "Buch", "Karow", "Rosenthal", "Wilhelmsruh", "Blankenburg", "Blankenfelde"],
    intro: [
      "Pankow ist der einwohnerstärkste Bezirk Berlins — und sehr vielfältig: dicht bebaute Altbauviertel in Prenzlauer Berg, Wohnsiedlungen in Weißensee und Einfamilienhäuser mit Gärten im grünen Norden rund um Buch, Karow und Rosenthal. Entsprechend unterschiedlich sind die Nagerprobleme: Ratten in Hinterhöfen und Kellern, Mäuse in Gartenhäusern, Dachböden und Garagen.",
      "Rodex Berlin ist in ganz Pankow im Einsatz — von der Altbauwohnung in Prenzlauer Berg bis zum Einfamilienhaus am Stadtrand. Wir analysieren Ihren konkreten Fall, bekämpfen gezielt und geben Ihnen Hinweise, wie Sie einem erneuten Befall vorbeugen.",
    ],
    hotspots: [
      "Altbau-Hinterhöfe und Kellerverschläge in Prenzlauer Berg",
      "Kompost, Gartenhäuser und Schuppen in den nördlichen Ortsteilen",
      "Garagen und Dachböden in Einfamilienhaus-Siedlungen",
      "Kitas, Schulen und Spielplätze mit Essensresten",
    ],
    faqs: [
      {
        q: "Ich habe Mäuse im Gartenhaus in Pankow — lohnt sich ein Profi?",
        a: "Gerade im Herbst ziehen Mäuse aus dem Garten in Schuppen und Häuser. Ein Profi bestimmt die Art, bekämpft gezielt und zeigt Ihnen, wo die Tiere hineinkommen — so verhindern Sie, dass sie ins Wohnhaus wandern.",
      },
      {
        q: "Arbeiten Sie auch für Kitas und Schulen in Pankow?",
        a: "Ja. Wir setzen in sensiblen Einrichtungen ausschließlich gesicherte Köderstationen ein und dokumentieren jeden Einsatz schriftlich.",
      },
    ],
  },
  {
    slug: "charlottenburg-wilmersdorf",
    name: "Charlottenburg-Wilmersdorf",
    tagline: "Gründerzeit-Altbau, Kudamm-Gastronomie & Villenlagen",
    ortsteile: ["Charlottenburg", "Wilmersdorf", "Westend", "Schmargendorf", "Grunewald", "Halensee", "Charlottenburg-Nord"],
    intro: [
      "Charlottenburg-Wilmersdorf verbindet repräsentative Gründerzeit-Altbauten, die Geschäfts- und Restaurantmeile rund um den Kurfürstendamm und ruhige Villenlagen im Grunewald und Westend. Hausverwaltungen, Gastronomen und Eigentümer erwarten hier vor allem eines: eine diskrete, saubere und gut dokumentierte Bekämpfung.",
      "Rodex Berlin übernimmt Rattenbekämpfung und Mäusebekämpfung in Charlottenburg-Wilmersdorf mit unauffälligen Fahrzeugen und schriftlichem Angebot vorab. Für Verwaltungen und Eigentümergemeinschaften erstellen wir nachvollziehbare Berichte für die Unterlagen.",
    ],
    hotspots: [
      "Großzügige Altbaukeller mit vielen Leitungsdurchführungen",
      "Gastronomie- und Hotelbetriebe rund um Kurfürstendamm und Savignyplatz",
      "Gärten und Nebengebäude von Villen im Grunewald und Westend",
      "Uferbereiche an Spree und Landwehrkanal in Charlottenburg",
    ],
    faqs: [
      {
        q: "Erstellen Sie Berichte für Hausverwaltungen in Charlottenburg?",
        a: "Ja. Sie erhalten eine schriftliche Dokumentation mit Befund, eingesetzten Mitteln, Standorten der Köderstationen und Empfehlungen — ideal für Verwaltungen und Eigentümerversammlungen.",
      },
      {
        q: "Kann der Einsatz diskret erfolgen, ohne dass Nachbarn es merken?",
        a: "Selbstverständlich. Unsere Fahrzeuge sind neutral, und wir stimmen den Termin so ab, wie es für Sie am besten passt.",
      },
    ],
  },
  {
    slug: "spandau",
    name: "Spandau",
    tagline: "Havel-Ufer, Wohnsiedlungen & Gewerbe",
    ortsteile: ["Spandau", "Wilhelmstadt", "Haselhorst", "Siemensstadt", "Staaken", "Hakenfelde", "Falkenhagener Feld", "Gatow", "Kladow"],
    intro: [
      "Spandau liegt an Havel und Spree und vereint Altstadt, große Wohnsiedlungen, Industrie- und Gewerbeflächen sowie ländlich geprägte Ortsteile wie Gatow und Kladow. Wasserläufe, Kleingärten und Lagerflächen bieten Ratten und Mäusen viele Rückzugsorte, von denen aus sie in Wohnhäuser und Betriebe vordringen.",
      "Wir sind in ganz Spandau schnell vor Ort — für Mieter, Eigentümer, Hausverwaltungen und Gewerbebetriebe. Nach einer gründlichen Ursachenanalyse bekämpfen wir den Befall gezielt und bieten Gewerbekunden auf Wunsch eine regelmäßige Überwachung an.",
    ],
    hotspots: [
      "Uferzonen an Havel und Spree",
      "Lager- und Produktionsflächen in Siemensstadt und Haselhorst",
      "Müllräume großer Wohnanlagen im Falkenhagener Feld und in Staaken",
      "Gärten, Schuppen und Ställe in Gatow und Kladow",
    ],
    faqs: [
      {
        q: "Bieten Sie in Spandau auch Dauerüberwachung für Betriebe an?",
        a: "Ja. Für Gewerbe, Lager und Lebensmittelbetriebe richten wir ein Monitoring mit festen Kontrollintervallen und lückenloser Dokumentation ein.",
      },
      {
        q: "Wie schnell sind Sie in Kladow oder Gatow?",
        a: "Wir melden uns innerhalb von 24 Stunden und vereinbaren zeitnah einen Termin — auch in den Randlagen Spandaus.",
      },
    ],
  },
  {
    slug: "steglitz-zehlendorf",
    name: "Steglitz-Zehlendorf",
    tagline: "Einfamilienhäuser, Gärten & Wald- und Seenlagen",
    ortsteile: ["Steglitz", "Lichterfelde", "Lankwitz", "Zehlendorf", "Dahlem", "Nikolassee", "Wannsee"],
    intro: [
      "Steglitz-Zehlendorf ist einer der grünsten Bezirke Berlins: Einfamilienhäuser mit Gärten, Villen am Wannsee, Wälder und Seen. Gerade hier sind Mäuse ein häufiges Thema — sie ziehen in der kalten Jahreszeit aus Garten und Wald in Keller, Garagen, Dachböden und Zwischendecken. Rund um die Schloßstraße in Steglitz kommen Ratten an Gastronomie und Geschäften dazu.",
      "Rodex Berlin bekämpft Mäuse und Ratten in Steglitz-Zehlendorf zuverlässig und mit Rücksicht auf Haustiere und Gartentiere. Nach der Bekämpfung erhalten Sie von uns konkrete Hinweise, über welche Stellen die Tiere ins Haus gelangt sind.",
    ],
    hotspots: [
      "Dachböden, Zwischendecken und Garagen von Einfamilienhäusern",
      "Kompost, Vogelfutterstellen und Gartenhäuser",
      "Keller älterer Villen in Dahlem, Lichterfelde und Zehlendorf",
      "Gastronomie und Einzelhandel rund um die Schloßstraße",
    ],
    faqs: [
      {
        q: "Ich höre nachts Kratzen in der Zwischendecke — sind das Mäuse?",
        a: "Sehr wahrscheinlich. Mäuse nutzen Zwischendecken und Hohlräume als Laufwege. Wir finden Laufwege und Nester und bekämpfen gezielt, ohne Ihre Haustiere zu gefährden.",
      },
      {
        q: "Ist Vogelfutter im Garten ein Problem?",
        a: "Herabgefallenes Vogelfutter zieht häufig Ratten und Mäuse an. Wir beraten Sie, wie Sie Futterstellen so gestalten, dass Nager keinen Zugang zur Nahrung haben.",
      },
    ],
  },
  {
    slug: "tempelhof-schoeneberg",
    name: "Tempelhof-Schöneberg",
    tagline: "Altbau-Kieze, Wohnsiedlungen & Gewerbegebiete",
    ortsteile: ["Schöneberg", "Friedenau", "Tempelhof", "Mariendorf", "Marienfelde", "Lichtenrade"],
    intro: [
      "Tempelhof-Schöneberg reicht vom dichten Altbau-Kiez in Schöneberg und Friedenau bis zu den Wohnsiedlungen und Gewerbegebieten in Mariendorf, Marienfelde und Lichtenrade. Der Teltowkanal, zahlreiche Kleingartenanlagen und Märkte wie am Winterfeldtplatz sorgen dafür, dass Ratten hier ein ganzjähriges Thema sind.",
      "Wir bekämpfen Ratten und Mäuse in Tempelhof-Schöneberg für Privathaushalte, Hausverwaltungen und Gewerbe — mit schriftlichem Angebot nach der Besichtigung und sauberer Dokumentation.",
    ],
    hotspots: [
      "Hinterhöfe und Altbaukeller in Schöneberg und Friedenau",
      "Kleingartenanlagen und Uferbereiche am Teltowkanal",
      "Gewerbe- und Lagerflächen in Tempelhof und Marienfelde",
      "Müllräume von Wohnanlagen in Mariendorf und Lichtenrade",
    ],
    faqs: [
      {
        q: "Bekämpfen Sie auch Ratten in Kleingartenanlagen?",
        a: "Ja. Für Kleingartenvereine und einzelne Parzellen setzen wir gesicherte Köderstationen ein und beraten zu Kompost, Futterquellen und Lagerung.",
      },
      {
        q: "Was kostet eine Rattenbekämpfung in Schöneberg?",
        a: "Das hängt vom Befall und der Fläche ab. Nach der kostenlosen Besichtigung erhalten Sie ein schriftliches Angebot — ohne versteckte Kosten.",
      },
    ],
  },
  {
    slug: "neukoelln",
    name: "Neukölln",
    tagline: "Dichte Kieze, Gastronomie & Gropiusstadt",
    ortsteile: ["Neukölln", "Britz", "Buckow", "Rudow", "Gropiusstadt"],
    intro: [
      "Neukölln vereint einen der dichtesten Altbau-Kieze Berlins im Norden mit Großsiedlungen wie der Gropiusstadt und eher ruhigen Wohnlagen in Britz, Buckow und Rudow. Rund um Sonnenallee, Karl-Marx-Straße, Hermannplatz und den Neuköllner Schifffahrtskanal führen viele Gastronomie- und Lebensmittelbetriebe dazu, dass Ratten in Hinterhöfen und Kellern regelmäßig auftauchen.",
      "Rodex Berlin bekämpft Ratten und Mäuse in Neukölln schnell, sicher und diskret — für Mieter, Hausverwaltungen, Restaurants und Lebensmittelhändler. Gewerbekunden erhalten eine HACCP-konforme Dokumentation für Kontrollen durch das Lebensmittelaufsichtsamt.",
    ],
    hotspots: [
      "Hinterhöfe mit Gastronomie- und Lebensmittelabfällen im Norden Neuköllns",
      "Keller und Müllräume in Großsiedlungen wie der Gropiusstadt",
      "Uferbereiche am Neuköllner Schifffahrtskanal",
      "Gärten, Schuppen und Kleingärten in Britz, Buckow und Rudow",
    ],
    faqs: [
      {
        q: "Mein Restaurant in Neukölln hat eine Kontrolle — können Sie schnell helfen?",
        a: "Ja. Wir melden uns innerhalb von 24 Stunden, bekämpfen den Befall gezielt und liefern Ihnen eine HACCP-konforme Dokumentation für die Behörde.",
      },
      {
        q: "Wir sehen Ratten im Hof unserer Wohnanlage — wer bezahlt?",
        a: "Für das Grundstück ist in der Regel der Eigentümer bzw. die Hausverwaltung zuständig. Informieren Sie Ihre Verwaltung — wir stimmen uns gern direkt mit ihr ab.",
      },
    ],
  },
  {
    slug: "treptow-koepenick",
    name: "Treptow-Köpenick",
    tagline: "Wasser, Wald & Einfamilienhaus-Siedlungen",
    ortsteile: ["Alt-Treptow", "Plänterwald", "Baumschulenweg", "Johannisthal", "Adlershof", "Niederschöneweide", "Oberschöneweide", "Köpenick", "Friedrichshagen", "Altglienicke", "Bohnsdorf", "Grünau", "Rahnsdorf", "Müggelheim", "Schmöckwitz"],
    intro: [
      "Treptow-Köpenick ist der flächengrößte Bezirk Berlins — mit Spree, Dahme, Müggelsee, großen Wäldern und vielen Einfamilienhaus- und Gartensiedlungen. Die Nähe zu Wasser und Grün bedeutet: Wanderratten an Ufern und Bootshäusern, Mäuse in Häusern, Lauben und Garagen, besonders in der kalten Jahreszeit.",
      "Rodex Berlin ist in allen Ortsteilen von Treptow-Köpenick im Einsatz — von Alt-Treptow bis Schmöckwitz. Wir finden heraus, woher die Tiere kommen, bekämpfen gezielt und zeigen Ihnen die Stellen, über die sie ins Gebäude gelangen.",
    ],
    hotspots: [
      "Uferbereiche, Bootshäuser und Stege an Spree, Dahme und Müggelsee",
      "Lauben, Gartenhäuser und Kompost in Gartensiedlungen",
      "Keller und Garagen von Einfamilienhäusern",
      "Gewerbe- und Technologiestandorte wie Adlershof und Schöneweide",
    ],
    faqs: [
      {
        q: "Haben Häuser am Wasser in Köpenick öfter Ratten?",
        a: "Wanderratten leben bevorzugt in Wassernähe. Ufergrundstücke sind daher häufiger betroffen. Eine regelmäßige Kontrolle hilft, einen Befall früh zu erkennen.",
      },
      {
        q: "Kommen Sie auch nach Müggelheim oder Schmöckwitz?",
        a: "Ja, wir betreuen ganz Treptow-Köpenick einschließlich der Randlagen.",
      },
    ],
  },
  {
    slug: "marzahn-hellersdorf",
    name: "Marzahn-Hellersdorf",
    tagline: "Großsiedlungen & Siedlungsgebiete",
    ortsteile: ["Marzahn", "Hellersdorf", "Biesdorf", "Kaulsdorf", "Mahlsdorf"],
    intro: [
      "Marzahn-Hellersdorf ist zweigeteilt: Auf der einen Seite stehen große Plattenbau-Siedlungen in Marzahn und Hellersdorf, auf der anderen eines der größten zusammenhängenden Einfamilienhausgebiete Deutschlands in Biesdorf, Kaulsdorf und Mahlsdorf. In den Großsiedlungen sind Müllräume und Keller typische Problemzonen, in den Siedlungsgebieten Gärten, Garagen und Dachböden.",
      "Wir bekämpfen Ratten und Mäuse in Marzahn-Hellersdorf für Wohnungsgesellschaften, Hausverwaltungen und private Eigentümer — gezielt, dokumentiert und mit einer klaren Empfehlung, wie Sie einem neuen Befall vorbeugen.",
    ],
    hotspots: [
      "Müllräume und Müllschlucker in Großsiedlungen",
      "Kellergänge und Versorgungsschächte in Plattenbauten",
      "Gärten, Kompost und Garagen in Biesdorf, Kaulsdorf und Mahlsdorf",
      "Gewerbeflächen und Supermärkte in den Stadtteilzentren",
    ],
    faqs: [
      {
        q: "Arbeiten Sie mit Wohnungsgesellschaften in Marzahn zusammen?",
        a: "Ja. Für größere Wohnanlagen bieten wir eine strukturierte Bekämpfung mit Dokumentation je Gebäude und auf Wunsch eine dauerhafte Überwachung an.",
      },
      {
        q: "Mäuse in der Garage in Mahlsdorf — was kann ich tun?",
        a: "Entfernen Sie offene Futterquellen wie Tierfutter oder Saatgut. Bei einem Befall bekämpfen wir gezielt und zeigen Ihnen, wo die Tiere in die Garage gelangen.",
      },
    ],
  },
  {
    slug: "lichtenberg",
    name: "Lichtenberg",
    tagline: "Wohnanlagen, Gewerbe & Ufer an der Rummelsburger Bucht",
    ortsteile: ["Lichtenberg", "Friedrichsfelde", "Karlshorst", "Rummelsburg", "Fennpfuhl", "Alt-Hohenschönhausen", "Neu-Hohenschönhausen", "Falkenberg", "Malchow", "Wartenberg"],
    intro: [
      "Lichtenberg bietet ein Nebeneinander aus großen Wohnanlagen in Hohenschönhausen und Fennpfuhl, neuen Quartieren an der Rummelsburger Bucht, Villen in Karlshorst und ausgedehnten Gewerbeflächen. Uferzonen, Kleingärten und Lagerbetriebe sind typische Ausgangspunkte für Ratten, die sich von dort in Wohngebäude ausbreiten.",
      "Rodex Berlin ist in allen Ortsteilen Lichtenbergs schnell vor Ort. Wir analysieren den Befall, bekämpfen mit gesicherten Köderstationen nach BfR-Leitlinien und erstellen für Verwaltungen und Gewerbe eine lückenlose Dokumentation.",
    ],
    hotspots: [
      "Müllräume und Keller großer Wohnanlagen in Hohenschönhausen",
      "Uferbereiche an der Rummelsburger Bucht",
      "Gewerbe- und Logistikflächen",
      "Gärten und Nebengebäude in Karlshorst und Malchow",
    ],
    faqs: [
      {
        q: "Wie läuft eine Bekämpfung in einer Wohnanlage in Hohenschönhausen ab?",
        a: "Nach einer Besichtigung legen wir die Standorte der Köderstationen fest, kontrollieren in festen Abständen und dokumentieren den Verlauf, bis der Befall beseitigt ist.",
      },
      {
        q: "Sind die Mittel für Mieter und Kinder sicher?",
        a: "Ja. Wir verwenden ausschließlich zugelassene Köder in verschlossenen, sabotagesicheren Boxen.",
      },
    ],
  },
  {
    slug: "reinickendorf",
    name: "Reinickendorf",
    tagline: "Tegeler See, Märkisches Viertel & Gartenstädte",
    ortsteile: ["Reinickendorf", "Tegel", "Wittenau", "Borsigwalde", "Märkisches Viertel", "Waidmannslust", "Lübars", "Hermsdorf", "Frohnau", "Heiligensee", "Konradshöhe"],
    intro: [
      "Reinickendorf reicht vom Tegeler See über das Märkische Viertel bis zu den Gartenstädten Frohnau und Hermsdorf und dem dörflichen Lübars. Wasser, Wald, Felder und große Wohnsiedlungen liegen dicht beieinander — Ratten finden hier an Ufern und in Müllräumen Unterschlupf, Mäuse ziehen gern in Häuser, Garagen und Ställe.",
      "Wir bekämpfen Ratten und Mäuse in Reinickendorf für Privathaushalte, Hausverwaltungen und Betriebe. Nach der Bekämpfung erhalten Sie von uns eine Analyse der Einstiegsstellen mit schriftlichen Empfehlungen.",
    ],
    hotspots: [
      "Uferbereiche am Tegeler See und am Tegeler Fließ",
      "Müllräume und Keller im Märkischen Viertel",
      "Einfamilienhäuser, Gärten und Garagen in Frohnau, Hermsdorf und Heiligensee",
      "Höfe, Ställe und Scheunen in Lübars",
    ],
    faqs: [
      {
        q: "Bekämpfen Sie auch Ratten auf Reiterhöfen oder in Ställen?",
        a: "Ja. Gerade dort, wo Tierfutter gelagert wird, setzen wir gesicherte Stationen ein, die für Pferde, Hunde und Katzen unzugänglich sind.",
      },
      {
        q: "Wie schnell kommen Sie nach Frohnau oder Heiligensee?",
        a: "Wir melden uns innerhalb von 24 Stunden und vereinbaren kurzfristig einen Termin vor Ort.",
      },
    ],
  },
];

export const getDistrict = (slug) => DISTRICTS.find((d) => d.slug === slug);
export const districtPath = (slug) => `/rattenbekaempfung/${slug}`;
